import React from 'react';

export default class Card extends React.Component {
    render() {

        return (
            <div {...this.props} className={['component-card', this.props.className].join(' ')}>
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./web-app/components/card.jsx